export default __webpack_public_path__ + "static/media/newyear2025-little.6cf544cd.png";